export default __webpack_public_path__ + "static/media/unsplash-2.695077e0.jpg";